import React from 'react';
import { Cookie, Globe, Shield, Lock, Database } from 'lucide-react';
import PolicySectionCard from '@/components/policy/PolicySectionCard';
import PageHeader from '@/components/layout/PageHeader';
import PolicyLayout from '@/components/policy/PolicyLayout';
import { motion } from 'framer-motion';

const CookiePolicy = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 }
  };

  return (
    <PolicyLayout>
      <PageHeader
        title="Cookie Policy"
        description="Last updated: April 11, 2025"
        icon={<Cookie className="w-8 h-8 text-primary" />}
      />

      {/* Cards Grid */}
      <motion.div 
        className="space-y-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={item}>
          <PolicySectionCard
            title="What Are Cookies?"
            icon={Cookie}
            variant="blue"
          >
            <p>Cookies are small text files stored on your device when you visit a website. They help us remember your preferences and understand how you interact with our platform.</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Types of Cookies We Use"
            icon={Shield}
            variant="purple"
          >
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Essential Cookies</strong> – Required for core functionalities such as authentication and security.</li>
              <li><strong>Performance Cookies</strong> – Help us analyze user behavior to improve performance.</li>
              <li><strong>Functional Cookies</strong> – Remember your preferences and personalize your experience.</li>
              <li><strong>Analytics and Marketing Cookies</strong> – Track engagement and help us serve relevant content or ads.</li>
            </ul>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Managing Cookies"
            icon={Globe}
            variant="teal"
          >
            <p>You can control or disable cookies via your browser settings. However, this may affect your ability to use some features of Edaptica.</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Third-Party Cookies"
            icon={Database}
            variant="rose"
          >
            <p>Some third-party services (like Google Analytics) may set their own cookies. These are subject to the third party's privacy policy.</p>
            <p className="mt-4">For any concerns, email: privacy@edaptica.com</p>
          </PolicySectionCard>
        </motion.div>
      </motion.div>
    </PolicyLayout>
  );
};

export default CookiePolicy;
